<template>
  <div class="runmode">
    <transition name="fade">
      <div v-show="showComponent">
        <!-- 戻る/進む -->
        <div class="goback">
          <div class="back" v-if="backDisabled"><button type=button v-on:click="backPathstep"></button></div>
          <div class="go" v-if="goDisabled"><button type=button v-on:click="goPathstep"></button></div>
        </div>

        <component v-bind:is="currentView" :pathstep="pathstepData" :productLanguage="productInfo.language" :scriptSystems="levelJson.scriptSystems"
                   @updateLearnedGroup="updateLearnedGroup" :changeTileFlag="changeTileFlag" :lang="productInfo.language" :isScrollIconVisible="isScrollIconVisible"
                   v-on:endAct="endAct" v-on:stopAct="stopAct"
                   v-on:showMicrophoneErrorDialog="showMicErrorDialog"
                   v-on:mounted="startBindView"
                   v-on:hintMouseDown="hintMouseDown" v-on:hintMouseUp="hintMouseUp"
                   v-on:hintMouseMove="hintMouseMove" v-on:changeTile="changeTile"
                   v-on:showScrollIcon="showScrollIcon"></component>
      </div>
    </transition>

    <!-- アクティビティ完了画面 -->
    <ActivityCompletion v-if="showCompletionView" :lessonIndex="completionLessonIndex" :pathTitle="completionPathTitle" :answerRate="completionAnswerRate" :ok="completionOk" :ng="completionNg" :skip="completionSkip" :total="completionTotal" :nextUnitNo="completionNextUnitNo" :nextUnitTitle="completionNextUnitTitle" :nextLessonIndex="completionNextLessonIndex" :nextPathTitle="completionNextPathTitle" v-on:clickButton="clickButtonCompletion"></ActivityCompletion>
    <!-- セクション警告ダイアログ画面 -->
    <SectionDialog v-if="showSectionDialogView"
        :answerRate="completionAnswerRate"
        :ok="completionOk" :ng="completionNg" :skip="completionSkip"
        :pathScore="currentPathScore"
        v-on:clickButton="clickButtonCompletion"></SectionDialog>
    <!-- スコアリセットダイアログ -->
    <ScoreReset v-if="showScoreReset" @clickButton="clickScoreResetButton"/>
    <!-- マイク設定確認ダイアログ -->
    <MicrophoneErrorDialog v-if="showMicrophoneErrorDialog" @startLesson="startLessonFromMicErrorDialog" @clickMicrophoneSetting="showMicSelect" @lessonContinue="lessonContinue" @showError="emitShowError" :productInfo="productInfo" />
    <!-- ヒントダイアログ -->
    <HintDialog v-if="showHintDialog" :hintText="hintText" :isHintHosoku="isHintHosoku"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";
import common from "@/mixin/common";
import http from "@/mixin/http";
import resource from "@/mixin/resource";
import commonLayout from "@/mixin/commonLayout";

import RunmodeLoading from "@/components/RunmodeLoading";
import ActivityCompletion from "@/components/ActivityCompletion";
import ScoreReset from "@/components/ScoreReset";
import MicrophoneErrorDialog from "@/components/MicrophoneSettingDialog";
import A1 from "@/components/runmode/A1";
import A1Q from "@/components/runmode/A1Q";
import A3 from "@/components/runmode/A3";
import A3Q from "@/components/runmode/A3Q";
import Tile from "@/components/runmode/Tile";
import P from "@/components/runmode/P";

import Milestone from "@/components/runmode/Milestone";

import SectionDialog from "@/components/SectionDialog";
import HintDialog from "@/components/HintDialog";

export default {
  name: "runmode",
  props: {
    jsonData: Object,
    productInfo: Object,
    showLessonScore: Boolean,
    showSetting: Boolean,
    showMicrophoneSelect: Boolean,
    clickToolbarLogo: Boolean,
    showLanguageLetter: Boolean,
    showProgressHandOver: Boolean
  },
  data: function() {
    return {
      currentView: "",
      nextView: "",
      currentMode: "",
      pathstepData: null,
      levelJson: null,
      showComponent: false,
      // ボタン制御用
      backDisabled: false,
      goDisabled: false,
      // アクティビティ完了画面用
      showCompletionView: false,
      completionLessonIndex: 0,
      completionPathTitle: "",
      completionAnswerRate: 0,
      completionOk: 0,
      completionNg: 0,
      completionSkip: 0,
      completionTotal: 0,
      completionNextUnitNo: 0,
      completionNextUnitTitle: "",
      completionNextLessonIndex: 0,
      completionNextPathIndex: 0,
      completionNextPathTitle: "",
      completionViewContinue: false,
      // マイク設定確認ダイアログ用
      showMicrophoneErrorDialog: false,
      // スコアリセットダイアログ用
      showScoreReset: false,
      // 次に実施するPathstepIndex
      nextPathstepIndex: -1,
      // セクション警告ダイアログ用
      showSectionDialogView: false,
      currentPathScore: {},
      // ヒントダイアログマウス移動範囲
      hintMouseMoveX: 0,
      hintMouseMoveY: 0,
      hintText: "",
      hintTargetId: false,
      // ヒントダイアログ補足フラグ
      isHintHosoku: false,
      // セクション開始pathstepIndex
      sectionStartPathstepIndex: 0,
      sectionNextPathstepIndex: 0,
      // P系RunmodeからTileに切り替える用のフラグ
      changeTileFlag: false,
      // スクロールアイコン表示フラグ
      isScrollIconVisible: false,
      // スクロール実施済みフラグ
      isScrolled: false,
      // スクロールアイコン非表示タイマー
      scrollIconVisibleTimer: null
    };
  },
  components: {
    RunmodeLoading,
    ActivityCompletion,
    ScoreReset,
    MicrophoneErrorDialog,
    A1,
    A1Q,
    A3,
    A3Q,
    Tile,
    P,
    Milestone,
    SectionDialog,
    HintDialog
  },
  mixins: [
    common,
    http,
    resource,
    commonLayout
  ],
  computed: {
    ...mapGetters([
      "levelNo",
      "unitNo",
      "lessonIndex",
      "pathIndex",
      "pathstepIndex",
      "lessonJson",
      "sreUse",
      "textSize"
    ]),
    // ヒントダイアログ表示フラグ
    showHintDialog: function() {
      return this.$store.getters.showHintDialog;
    }
  },
  methods: {
    /**
     * P系の音声認識OFF時かつconfusersがある場合はTileにする
     */
    changeTile: function() {
      this.changeTileFlag = true;
      this.startLesson(this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex, this.lessonJson);
    },
    /**
     * ホーム画面へ遷移させるため、親へ通知
     */
    endPath: function() {
      this.log("Runmode start endLesson");
      this.$emit("endLesson");
    },
    /**
     * エラー表示のため、親へ通知
     */
    emitShowError: function(message, buttonKind) {
      this.log("Runmode start showError");
      this.showMicrophoneErrorDialog = false;
      this.$emit("showError", message, buttonKind);
    },
    /**
     * マイク設定画面を表示するため、親へ通知
     */
    showMicSelect: function() {
      this.log("Runmode start showMicSelect");
      this.$emit("showMicrophoneSelect", false);
    },
    /**
     * 進捗引継ぎ確認画面表示のため、親へ通知
     */
    emitShowProgressHandOver: function(unitNo, lessonIndex, pathIndex, pathstepIndex, json) {
      this.log("Runmode start emitShowProgressHandOver");
      this.$emit("showProgressHandOver", unitNo, lessonIndex, pathIndex, pathstepIndex, json);
    },
    /**
     * コンポーネントを切り替える
     * 前回と同じコンポーネントを表示する場合、mountedが呼ばれないため、
     * 別画面を表示後に切り替えるようにする
     */
    startBindView: function() {
      this.log("Runmode start startBindView");

      // フェードイン
      var self = this;
      setTimeout(function() {
        self.currentView = self.nextView;
        self.showComponent = true;

        clearTimeout(self.scrollIconVisibleTimer);
        self.isScrolled = false;
        self.isScrollIconVisible = false;

        // スコアを確認
        var pathstepIndex = self.$store.getters.pathstepIndex;
        var currentPath = self.$store.getters.currentPath;
        var pathstep = currentPath.pathsteps[pathstepIndex];

        var val = pathstep.ok + pathstep.ng;
        if (val == 0) {
          var apiData = self.createProgressValue();

          // 進捗/スコアをDBに保存
          self.doSetKeyValue(apiData).then(function() {
            // スコアを初期化
            self.$store.dispatch("setPathstepAllSkip");

            return new Promise(function(resolve, reject) {
              // コンテンツ全体進捗設定処理
              self.setAllProgress().then(function() {
                // state更新
                self.log("set LessonState: " + storeConstants.LESSON_STATE_START);
                self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_START);
              }).catch(function(message) {
                reject(message);
              });
            });
          }).catch(function(message) {
            if (message.length != 0) {
              self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
            }
          });
        } else {
          // スコアリセットダイアログを表示
          self.showScoreReset = true;
        }
      }, 500);
    },
    /**
     * 出題が終了
     * 子コンポーネントから上がってくるイベント
     */
    endAct: function() {
      this.doEndAct(false);
    },
    doEndAct: function(isForcedTransition) {
      this.log("Runmode start endAct");

      var self = this;
      var apiData = this.createScoreValue();

      // ヒントダイアログマウスイベント初期化
      this.hintMouseMoveStart = false;

      // Tile切り替えフラグ初期化
      if (this.changeTileFlag === true) {
        this.changeTileFlag === false;
      }

      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            if (self.pathstepData.mode !== constants.RUNMODE_MILESTONE) {
              // 自動的に次に進むか確認(goPathstepから呼び出された場合は無視する)
              if (!isForcedTransition && self.$store.getters.autoScreenTransition !== "true") {
                return;
              }
            }

            // 最終問題か確認
            var isLast = self.isLastPathstepIndex();
            if (!isLast) {
              // セクションの最終問題か確認
              var sectionScore = false;
              if (self.checkEndSection(self.pathstepData.id)) {
                // セクションスコア計算
                sectionScore = self.calcSectionScore(self.pathstepData.id);
              }
              if (sectionScore === false) {
                // 次の問題へ
                var newIndex = self.pathstepIndex + 1;
                self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, newIndex, self.lessonJson);
              } else {
                // セクションダイアログ表示
                self.showSectionDialogView = true;
                self.completionAnswerRate = sectionScore.answerRate;
                self.completionOk = sectionScore.ok;
                self.completionNg = sectionScore.ng;
                self.completionSkip = sectionScore.skip;
                self.sectionStartPathstepIndex = sectionScore.startPathstepIndex;
                self.sectionNextPathstepIndex = self.pathstepIndex + 1;
                self.currentPathScore = sectionScore.pathScore;
              }
            } else {
              // state更新
              self.log("set LessonState: " + storeConstants.LESSON_STATE_END);
              self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_END);

              // アクティビティ完了画面を表示
              self.doShowCompletionView();
            }
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * 出題を中断
     * 子コンポーネントから上がってくるイベント
     *
     * 以下の操作に発生する想定
     * ・前へ/次へボタン押下時
     * ・レッスンスコア画面で、レッスンを選択した時
     * ・ツールバーのロゴ押下時
     */
    stopAct: function() {
      this.log("Runmode start stopAct");

      // ツールバーのログを押下して出題を中断した場合
      if (this.clickToolbarLogo) {
        // ホーム画面を表示する
        this.endPath();
        return;
      }

      var self = this;
      var apiData = this.createScoreValue();

      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            if (self.nextPathstepIndex == -1) {
              return;
            }

            self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, self.nextPathstepIndex, self.lessonJson);

            // 初期化
            self.nextPathstepIndex = -1;
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * マイク設定確認ダイアログを表示
     * 子コンポーネントから上がってくるイベント
     */
    showMicErrorDialog: function() {
      this.log("Runmode start showMicErrorDialog");

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);

      this.showMicrophoneErrorDialog = true;
    },
    /**
     * 前のPathstepへ移動
     */
    backPathstep: function() {
      this.log("Runmode start backPathstep");

      // ボタン連打用処理
      switch (this.$store.getters.lessonState) {
        case storeConstants.LESSON_STATE_START:
        case storeConstants.LESSON_STATE_RESTART:
          // 処理継続
          break;
        default:
          // 何もしない
          return;
      }

      // 学習済グループチェック
      if (!this.checkLearnedGroup()) {
        // 未学習の場合、ヘルプダイアログ表示
        this.hintHosokuDisp();
        this.updateLearnedGroup();
        return;
      }

      // 次のPathstepIndexを設定
      this.setNextPathstepIndex(this.pathstepIndex - 1);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    },
    /**
     * 次のPathstepへ移動
     */
    goPathstep: function() {
      this.log("Runmode start goPathstep");

      // ボタン連打用処理
      switch (this.$store.getters.lessonState) {
        case storeConstants.LESSON_STATE_START:
        case storeConstants.LESSON_STATE_RESTART:
          // 処理継続
          break;
        default:
          // 何もしない
          return;
      }

      // マイルストーンの場合
      if (this.pathstepData.mode === constants.RUNMODE_MILESTONE) {
        for (var rootChild of this.$children) {
          if (rootChild.$options.name === "Milestone") {
            rootChild.goGroup();
            break;
          }
        }
        return;
      }

      // 最終問題か確認
      var isLast = this.isLastPathstepIndex();
      if(isLast) {
        this.doEndAct(true);
        return;
      }

      // セクション警告ダイアログ
      var sectionScore = false;
      if (this.checkEndSection(this.pathstepData.id)) {
        // セクションスコア計算
        sectionScore = this.calcSectionScore(this.pathstepData.id);
        if (sectionScore) {
          // セクションダイアログ表示
          this.showSectionDialogView = true;
          this.completionAnswerRate = sectionScore.answerRate;
          this.completionOk = sectionScore.ok;
          this.completionNg = sectionScore.ng;
          this.completionSkip = sectionScore.skip;
          this.sectionStartPathstepIndex = sectionScore.startPathstepIndex;
          this.sectionNextPathstepIndex = this.pathstepIndex + 1;
          this.currentPathScore = sectionScore.pathScore;
          this.log("set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
          this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
          return;
        }
      }

      // 学習済グループチェック
      if (!this.checkLearnedGroup()) {
        // 未学習の場合、ヘルプダイアログ表示
        this.hintHosokuDisp();
        this.updateLearnedGroup();
        return;
      }

      // 次のPathstepIndexを設定
      this.setNextPathstepIndex(this.pathstepIndex + 1);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    },
    /**
     * 前/次ボタンの表示制御
     */
    setButtonDisabled: function(mode) {
      var len = 0;

      // 復習の場合は非表示
      if (this.lessonJson.paths[this.pathIndex].title === constants.PATH_TITLE_REVIEW) {
        this.backDisabled = false;
        this.goDisabled = false;
        return;
      }

      // マイルストーンの場合
      if (mode === constants.RUNMODE_MILESTONE) {
        this.backDisabled = false;
        this.goDisabled = true;
        return;
      }

      len = this.lessonJson.paths[this.pathIndex].pathsteps.length - 1;
      if (len == this.pathstepIndex && this.pathstepIndex == 0) {
        // 前／次問題がない場合
        this.backDisabled = false;
        this.goDisabled = false;
      } else if (this.pathstepIndex == 0) {
        // 始め
        this.backDisabled = false;
        this.goDisabled = true;
      } else if (len == this.pathstepIndex) {
        // 最後
        this.backDisabled = true;

        if(this.$store.getters.autoScreenTransition !== "true") {
          this.goDisabled = true;
        } else {
          this.goDisabled = false;
        }
      } else {
        this.backDisabled = true;
        this.goDisabled = true;
      }
    },
    /**
     * 次のPathstepIndexを設定
     * 子コンポーネントの終了処理完了後(stopAct)に、次のレッスンを開始するため、
     * 次のPathstepIndexを保持する
     */
    setNextPathstepIndex: function(newIndex) {
      this.log("Runmode start setNextPathstepIndex: " + newIndex);
      this.nextPathstepIndex = newIndex;

      for (var child of this.$children) {
        if (child.allCorrectTimer != null) {
          clearTimeout(child.allCorrectTimer);
        }
      }
    },
    /**
     * レッスン開始前に、storeにデータを保存
     */
    startLesson: function(newUnitNo, newLessonIndex, newPathIndex, newPathstepIndex, newLessonJson) {
      this.log("Runmode start startLesson newUnitNo: " + newUnitNo + ", newLessonIndex: " + newLessonIndex + ", newPathIndex: " + newPathIndex + ", newPathstepIndex: " + newPathstepIndex);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

      this.showScoreReset = false;

      this.$store.dispatch("setUnitNo", newUnitNo);
      this.$store.dispatch("setLessonIndex", newLessonIndex);
      this.$store.dispatch("setPathIndex", newPathIndex);
      this.$store.dispatch("setPathstepIndex", newPathstepIndex);
      this.$store.dispatch("setLessonJson", newLessonJson);

      // アクティビティ完了画面で"続行"押下された場合
      if (this.completionViewContinue) {
        this.completionViewContinue = false;
      }

      this.doStartLesson();
    },
    /**
     * レッスン開始
     */
    doStartLesson: function() {
      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

      var self = this;

      // フェードアウト
      this.showComponent = false;

      // 全解答表示の値をリセット
      this.$store.dispatch("setShowAllAnswer", false);

      setTimeout(function() {
        // コンポーネントに渡すデータを設定
        var tempPathData = self.lessonJson.paths[self.pathIndex];
        var tempPathstepData = tempPathData.pathsteps[self.pathstepIndex];
        self.pathstepData = self.getLayoutPathstep(tempPathstepData);

        // Pathstep内リソース更新
        self.updatePathstepResources(self.pathstepData);

        // ボタン表示制御
        self.setButtonDisabled(self.pathstepData.mode);

        // P系の音声認識OFF時かつconfusersがある場合はTileにする
        self.checkNeedChangeTile();
        if (self.changeTileFlag) {
          self.setRunmode(constants.RUNMODE_TILE);
        } else {
          // 使用するコンポーネントを設定
          self.setRunmode(self.pathstepData.mode);
        }

        // 現在のmodeGroupを設定
        self.$store.dispatch("setModeGroup", self.getModeGroup());

        // 表示モード切替
        self.changeDisplayMode(self.productInfo.language, tempPathData.type);

        self.currentView = "RunmodeLoading";
      }, 500);
    },
    /**
     * RunmodeをTileにする必要があるかどうかチェックする
     */
    checkNeedChangeTile: function() {
      this.changeTileFlag = false;

      switch (this.pathstepData.mode) {
        case constants.RUNMODE_PSPEECH:
        case constants.RUNMODE_SPEECH:
        case constants.RUNMODE_PNTSPEECH:
        case constants.RUNMODE_PNS:
          if (this.$store.getters.sreUse != "true") {
            // confusersが存在するactがあればRunmodeをTileに切り替える
            for (var i = 0; i < this.pathstepData.acts.length; i++) {
              var act = this.pathstepData.acts[i];
              for (var j = 0; j < act.texts.length; j++) {
                var text = act.texts[j];
                if (text.confusers.length != 0) {
                  this.changeTileFlag = true;
                  return;
                }
              }
            }
          }
          break;
        default:
          // Ignore
          break;
      }
    },
    /**
     * modeから使用するコンポーネントを設定
     */
    setRunmode: function(mode) {
      this.log("Runmode start setRunmode: " + mode);

      this.currentMode = mode;

      switch (mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_FAD:
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_C1:
        case constants.RUNMODE_C1O:
        case constants.RUNMODE_A4:
        case constants.RUNMODE_A4O:
          this.nextView = "A1";
          break;
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_B1Q:
        case constants.RUNMODE_C1Q:
          this.nextView = "A1Q";
          break;
        case constants.RUNMODE_A3Q:
        case constants.RUNMODE_ThreeTwoOne:
        case constants.RUNMODE_TwoTwo:
          this.nextView = "A3Q";
          break;
        case constants.RUNMODE_A3:
        case constants.RUNMODE_A3O:
        case constants.RUNMODE_C3:
        case constants.RUNMODE_C3O:
          this.nextView = "A3";
          break;
        case constants.RUNMODE_TILE:
        case constants.RUNMODE_STILE:
        case constants.RUNMODE_LTILE:
          this.nextView = "Tile";
          break;
        case constants.RUNMODE_P:
        case constants.RUNMODE_PNT:
        case constants.RUNMODE_PNS:
        case constants.RUNMODE_PSPEECH:
        case constants.RUNMODE_PNTSPEECH:
        case constants.RUNMODE_SPEECH:
          this.nextView = "P";
          break;
        case constants.RUNMODE_MILESTONE:
          this.nextView = "Milestone";
          break;
        default:
          break;
      }
    },
    /**
     * スコアとリビジョンのAPI送信用のデータを作成
     */
    createScoreValue: function() {
      // スコアを取得
      var pathScore = this.$store.getters.currentPath;
      var pathstepScore = pathScore.pathsteps[this.pathstepIndex];

      // API送信のデータを作成
      var score = this.createScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex, pathstepScore.ok, pathstepScore.ng, pathstepScore.skip);
      var unitJson = this.getUnitJson(this.levelJson, this.unitNo);
      var revision = unitJson.lessons[this.lessonIndex].paths[this.pathIndex].revision;
      var revisionData = this.createRevisionDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, revision);
      var apiData = '{"data":[' + score + ", " + revisionData + "]}";

      return apiData;
    },
    /**
     * 進捗のAPI送信用のデータを作成
     */
    createProgressValue: function() {
      // storeの進捗を更新
      var params = { levelNo: this.levelNo, unitNo: this.unitNo, lessonIndex: this.lessonIndex, pathIndex: this.pathIndex, pathstepIndex: this.pathstepIndex };
      this.$store.dispatch("updateProgress", params);

      // 進捗データ
      var progress = this.createProgressDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex);

      // pathstep数の確認
      var currentPath = this.$store.getters.currentPath;
      var pathstepLength = currentPath.pathsteps.length;
      var pathstepLengthData = this.createPathStepLengthForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, pathstepLength);

      // challenge数を確認
      var challengeData = [];
      for (var i = 0; i < pathstepLength; i++) {
        var pathstep = this.lessonJson.paths[this.pathIndex].pathsteps[i];
        var count = pathstep.acts.filter(function(act) { return act.usage == 1; }).length;

        var data = this.createPathStepChallengeForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, i, count);
        challengeData.push(data);
      }

      // 学習状態更新
      var studyState = this.createStudyStatusDataForApi(true)

      // API送信のデータを作成
      var apiData = '{"data":[' + progress + ", " + pathstepLengthData + ", " + challengeData + ", " +  studyState + "]}";

      return apiData;
    },
    /**
     * リセット時のAPI送信用のデータを作成
     */
    createResetValue: function() {
      // storeの進捗を更新
      var params = { levelNo: this.levelNo, unitNo: this.unitNo, lessonIndex: this.lessonIndex, pathIndex: this.pathIndex, pathstepIndex: this.pathstepIndex };
      this.$store.dispatch("updateProgress", params);

      // 進捗データ
      var progress = this.createProgressDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex);

      // pathstep数の確認
      var currentPath = this.$store.getters.currentPath;
      var pathstepLength = currentPath.pathsteps.length;
      var pathstepLengthData = this.createPathStepLengthForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, pathstepLength);

      // challenge数を確認
      var challengeData = [];
      for (var i = 0; i < pathstepLength; i++) {
        var pathstep = this.lessonJson.paths[this.pathIndex].pathsteps[i];
        var count = pathstep.acts.filter(function(act) { return act.usage == 1; }).length;

        var data = this.createPathStepChallengeForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, i, count);
        challengeData.push(data);
      }

      // スコアを初期化
      this.$store.dispatch("setPathstepAllSkip");

      // スコアを取得
      var pathScore = this.$store.getters.currentPath;
      var pathstepScore = pathScore.pathsteps[this.pathstepIndex];

      var score = this.createScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex, pathstepScore.ok, pathstepScore.ng, pathstepScore.skip);
      var unitJson = this.getUnitJson(this.levelJson, this.unitNo);
      var revision = unitJson.lessons[this.lessonIndex].paths[this.pathIndex].revision;
      var revisionData = this.createRevisionDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, revision);

      // API送信のデータを作成
      var apiData = '{"data":[' + progress + ", " + pathstepLengthData + ", " + challengeData + ", " + score + ", " + revisionData + "]}";

      return apiData;
    },
    /**
     * key-value設定APIを実行
     */
    doSetKeyValue: async function(datajson) {
      this.log("Runmode start doSetKeyValue");
      var self = this;

      // アクセスキー取得
      // 非同期処理(WebAPI実行)を並列実行する場合、
      // 事前にアクセスキーを取得する必要があるため、
      // ここで取得
      var accessKey = await storage_wrapper.getRsAccessKey();

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson, accessKey).then(function(response) {
          self.log("Runmode doSetKeyValue resultCode: " + response.result_code);
          switch (response.result_code) {
            case "OK":
              resolve();
              break;
            case "INFO_INVALID_ACCESSKEY":
              var message = response.result_code;
              reject(message);
              break;
            default:
              resolve();
              break;
          }
        }).catch(function(err) {
          resolve();
        });
      });
    },
    /**
     * 進捗率設定APIを実行
     */
    doRegisterProgress: async function(progress) {
      this.log("Runmode start doRegisterProgress");
      var self = this;

      // アクセスキー取得
      // 非同期処理(WebAPI実行)を並列実行する場合、
      // 事前にアクセスキーを取得する必要があるため、
      // ここで取得
      var accessKey = await storage_wrapper.getRsAccessKey();

      return new Promise(function(resolve, reject) {
        // 進捗率設定API
        self.registerProgress(self.productInfo.code, progress, accessKey).then(function(response) {
          self.log("Runmode registerProgress resultCode: " + response.result_code);
          switch (response.result_code) {
            case "OK":
              resolve();
              break;
            case "INFO_INVALID_ACCESSKEY":
              var message = response.result_code;
              reject(message);
              break;
            default:
              resolve();
              break;
          }
        }).catch(function(err) {
          resolve();
        });
      });
    },
    /**
     * アクティビティ完了画面を表示
     */
    doShowCompletionView: function() {
      this.log("Runmode start doShowCompletionView");

      var pathScore = this.$store.getters.currentPath;

      this.completionLessonIndex = this.lessonIndex;
      this.completionPathTitle = pathScore.title;
      this.completionAnswerRate = pathScore.answerRate;
      this.completionOk = pathScore.ok;
      this.completionNg = pathScore.ng;
      this.completionSkip = pathScore.skip;
      this.completionTotal = pathScore.total;

      var unitJson = this.getUnitJson(this.levelJson, this.unitNo);
      var pathLen = this.lessonJson.paths.length - 1;
      var lessonLen = unitJson.lessons.length - 1;
      var unitLen = this.levelJson.units.length - 1;
      var unitIndex = this.getUnitIndex(this.levelJson, this.unitNo);

      this.completionNextUnitNo = this.unitNo;
      this.completionNextUnitTitle = unitJson.title;
      this.completionNextLessonIndex = this.lessonIndex;

      if (pathLen == this.pathIndex) {
        if (lessonLen == this.lessonIndex) {
          var json = null;
          if (unitLen == unitIndex) {
            // 始めのunit
            json = this.levelJson.units[0];
          } else {
            // 次のunit
            json = this.levelJson.units[unitIndex + 1];
          }
          this.completionNextUnitNo = json.unitNo;
          this.completionNextUnitTitle = json.title;
          this.completionNextLessonIndex = 0;
          this.completionNextPathIndex = 0;
          this.completionNextPathTitle = json.lessons[0].paths[0].title;
        } else {
          // 次のlesson
          this.completionNextLessonIndex = this.lessonIndex + 1;
          this.completionNextPathIndex = 0;
          this.completionNextPathTitle = unitJson.lessons[this.lessonIndex + 1].paths[0].title;
        }
      } else {
        // 次のpath
        this.completionNextPathIndex = this.pathIndex + 1;
        this.completionNextPathTitle = unitJson.lessons[this.lessonIndex].paths[this.pathIndex + 1].title;
      }

      this.showCompletionView = true;
    },
    /**
     * アクティビティ完了画面でボタン押下された場合の処理
     */
    clickButtonCompletion: async function(buttonkind) {
      this.log("Runmode start clickButtonCompletion");

      this.showCompletionView = false;
      this.showSectionDialogView = false;
      switch (buttonkind) {
        case "home":
          this.endPath();
          break;
        case "repeat":
          this.repeatLesson();
          break;
        case "continue":
          this.completionViewContinue = true;

          // 最後に実施したpathStepを取得
          var params = { levelNo: this.levelNo, unitNo: this.completionNextUnitNo, lessonIndex: this.completionNextLessonIndex, pathIndex: this.completionNextPathIndex };
          var pathStepIndex = this.$store.getters.filterProgress(params);
          var unitJson = this.getUnitJson(this.levelJson, this.completionNextUnitNo);
          var lessonJson = unitJson.lessons[this.completionNextLessonIndex];

          // 対象Pathをロードし、Pathstepsを設定する
          var path = lessonJson.paths[this.completionNextPathIndex];
          await this.setPathsteps(this.completionNextUnitNo, this.completionNextLessonIndex, path);

          // スコア更新
          params.pathsteps = path.pathsteps;
          this.$store.dispatch("initPathScore", params);
          this.setStorePathScore(this.$store.getters.score, this.levelNo, this.completionNextUnitNo, this.completionNextLessonIndex, this.completionNextPathIndex);

          if (pathStepIndex == -1) {
            this.startLesson(this.completionNextUnitNo, this.completionNextLessonIndex, this.completionNextPathIndex, 0, lessonJson);
          } else {
            // 進捗引継ぎ確認画面を表示
            this.emitShowProgressHandOver(this.completionNextUnitNo, this.completionNextLessonIndex, this.completionNextPathIndex, pathStepIndex, lessonJson);
          }
          break;
        case "repeatSection":
          // セクションを繰り返す
          var newIndex = this.sectionStartPathstepIndex;
          this.startLesson(this.unitNo, this.lessonIndex, this.pathIndex, newIndex, this.lessonJson);
          break;
        case "nextSection":
          // 次のセクションへ
          var newIndex = this.pathstepIndex + 1;
          this.startLesson(this.unitNo, this.lessonIndex, this.pathIndex, newIndex, this.lessonJson);
          break;
        default:
          break;
      }
    },
    /**
     * レッスンを繰り返す
     */
    repeatLesson: function() {
      this.log("Runmode start repeatLesson");

      // storeのスコアをリセット
      this.$store.dispatch("setPathAllReset");

      // json作成
      var pathstepLength = this.lessonJson.paths[this.pathIndex].pathsteps.length;
      var score = this.createResetScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, pathstepLength);
      var apiData = '{"data":[' + score + "]}";

      var self = this;
      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            // レッスン開始
            self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, 0, self.lessonJson);
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * 音声停止処理
     */
    audioPause: function() {
      this.log("Runmode start audioPause");

      this.$emit("audioPause");
    },
    /**
     * マイク設定確認ダイアログを閉じて、レッスンを再実施
     */
    startLessonFromMicErrorDialog: function() {
      this.log("Runmode start startLessonFromMicErrorDialog");
      this.showMicrophoneErrorDialog = false;
      this.doStartLesson();
    },
    /**
     * マイク設定確認ダイアログを閉じて、レッスンを再開
     */
    lessonContinue: function() {
      this.log("Runmode start lessonContinue");

      this.showMicrophoneErrorDialog = false;

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * レッスン準備
     */
    prepareLesson: function() {
      this.log("Runmode start prepareLesson");

      this.doStartLesson();
    },
    /**
     * スコアリセットダイアログのボタン押下時の処理
     */
    clickScoreResetButton: function(kind) {
      this.log("Runmode start clickScoreResetButton: " + kind);

      if (kind === "home") {
        // state更新
        this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);

        // ホーム画面へ遷移
        this.showScoreReset = false;
        this.endPath();
      } else if (kind === "lessonScore") {
        // レッスンスコアを表示
        this.$emit("showLessonScore");
      } else {
        var self = this;
        var apiData = this.createResetValue();

        // 進捗/スコアをDBに保存
        this.doSetKeyValue(apiData).then(function() {
          self.showScoreReset = false;

          return new Promise(function(resolve, reject) {
            // コンテンツ全体進捗設定処理
            self.setAllProgress().then(function() {
              // state更新
              self.log("set LessonState: " + storeConstants.LESSON_STATE_START);
              self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_START);
            }).catch(function(message) {
              reject(message);
            });
          });
        }).catch(function(message) {
          if (message.length != 0) {
            self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
          }
        });
      }
    },
    /**
     * コンテンツ全体進捗設定処理
     */
    setAllProgress: function() {
      this.log("Runmode start setAllProgress");

      // 実行環境がau/softbank版Androidアプリの場合は終了
      if (this.isAu() || this.isSoftbank()) {
        return Promise.resolve();
      }

      // コンテンツ全体進捗設定処理
      var total = this.productInfo.challengeCount ? this.productInfo.challengeCount : 0;
      var progress = this.$store.getters.allProgress(total);
      return this.doRegisterProgress(progress);
    },
    /**
     * モバイルアプリ版：端末電源ON時の開始コールバック
     */
    ROSETTA_SRE_onStart: function() {
      this.log("ROSETTA_SRE_onStart start");

      // ダイアログ表示中の場合は、何もしない
      if (this.showLessonScore ||
          this.showSetting ||
          this.showMicrophoneSelect ||
          this.showLanguageLetter ||
          this.showHintDialog ||
          this.showMicrophoneErrorDialog ||
          this.showSectionDialogView ||
          this.showCompletionView ||
          this.showScoreReset ||
          this.showProgressHandOver) {
        return;
      }
      // 引継ぎコード発行画面表示中の場合は、何もしない
      for (var child of this.$parent.$children) {
        if (child.$options.name == "toolbar") {
          if (child.isTakeOverVisible) {
            return;
          } else {
            break;
          }
        }
      }
      // 拡大表示中は何もしない
      if (this.$store.getters.showPinchIn) {
        return;
      }

      // state更新
      this.log("ROSETTA_SRE_onStart set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * モバイルアプリ版：端末電源OFF時の停止コールバック
     */
    ROSETTA_SRE_onStop: function() {
      this.log("ROSETTA_SRE_onStop start");
      // state更新
      this.log("ROSETTA_SRE_onStop set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
      // 音声停止
      this.$emit("audioPause");
    },
    /**
     * ドコモ版：プッシュ通知ダイアログ終了コールバック
     */
    ROSETTA_onPushSetting: function() {
      this.log("ROSETTA_onPushSetting start");

      // state更新
      this.log("ROSETTA_onPushSetting set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * モバイルアプリ版：アクセスキー無効エラー発生コールバック
     */
    ROSETTA_onErrorAccessKey: function() {
      this.log("ROSETTA_onErrorAccessKey start");

      // state更新
      this.log("ROSETTA_onErrorAccessKey set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
      // 音声停止
      this.$emit("audioPause");

      var message = "INFO_INVALID_ACCESSKEY";
      this.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
    },
    /**
     * ヒントダイアログ:マウスDown
     * @param object event
     */
    hintMouseDown: function(event) {
      if (!this.isEnvironmentPc()) {
        // スマホは無効
        return;
      }
      if (typeof event.target.id !== "undefined") {
        this.hintMouseMoveX = event.pageX;
        this.hintMouseMoveY = event.pageY;
        this.hintTargetId = event.target.id;
      }
    },
    /**
     * ヒントダイアログ:マウスUp
     * @param object event
     */
    hintMouseUp: function(event) {
      if (!this.isEnvironmentPc()) {
        // スマホは無効
        return;
      }
      this.hintTargetId = false;
    },
    /**
     * ヒントダイアログ:マウスMove
     * @param object event
     */
    hintMouseMove: function(event) {
      if (!this.isEnvironmentPc()) {
        // スマホは無効
        return;
      }
      if (this.hintTargetId !== false) {
        // 同じ要素かチェック
        if (event.target.id == this.hintTargetId) {
          // ドラック可能領域外かチェック
          if (Math.abs(event.pageX - this.hintMouseMoveX) > constants.HINT_DIALOG_MOUSE_DRUG_AREA ||
              Math.abs(event.pageY - this.hintMouseMoveY) > constants.HINT_DIALOG_MOUSE_DRUG_AREA) {
            this.hintTargetId = false;
            // ヘルプダイアログ表示
            this.doShowHintDialog();
          }
        }
      }
    },
    /**
     * ヘルプダイアログ：補足表示
     * @returns {undefined}
     */
    hintHosokuDisp: function() {
      this.isHintHosoku = true;
      this.doShowHintDialog();
    },
    /**
     * ヒントダイアログ表示実行
     * @returns {undefined}
     */
    doShowHintDialog: function() {
      this.$store.dispatch("setShowHintDialog", true);

      var modeGroup = this.getModeGroup();
      if (this.isHintHosoku) {
        this.hintText = this.getHelpDialogHosokuText(modeGroup, this.sreUse);
      } else {
        this.hintText = this.getHelpDialogText(modeGroup, this.sreUse);
      }
    },
    /**
     * 学習済グループ更新
     */
    updateLearnedGroup: function() {
      this.log("Runmode start updateLearnedGroup");

      var modeGroup = this.getModeGroup();

      if (this.checkLearnedGroup(modeGroup)) {
        // 学習済グループ設定済
        return;
      }

      var self = this;

      if (modeGroup) {
        // APIキー
        var key = constants.DATA_LEARNED_GROUP + modeGroup;
        // API登録データ生成
        var apiData = '{"data":[{"' + key + '":"true"}]}';
        // storeに保存
        self.$store.dispatch("setLearnedGroup", { key: key, val: "true" });
        // API登録実行
        this.doSetKeyValue(apiData).then(function() {
          // 更新成功
          self.log("set LearnedGroup " + true);
        }).catch(function(message) {
          self.log("set LearnedGroup Error");
        });
      }
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @param {String} key キー名
     * @param {String} value 設定値
     * @return {Object} key-valueオブジェクト
     */
    getApiParamKeyValue: function(key, value) {
      var result = {};
      result[key] = value;
      return result;
    },
    /**
     * Runmodeグループ取得
     * @returns string modeGroup
     */
    getModeGroup: function() {
      var mode = this.pathstepData.modeGroup;
      if (mode === constants.MODE_GROUP_SPEECH) {
        if (this.sreUse != "true") {
          mode = constants.MODE_GROUP_TILE;
        }
      }

      return mode;
    },
    /**
     * 学習済グループチェック
     * @returns {unresolved}
     */
    checkLearnedGroup: function(modeGroup) {
      if (!modeGroup) {
        modeGroup = this.getModeGroup();
      }
      return this.$store.getters.learnedGroup(modeGroup) == "true";
    },
    /**
     * セクションの最終問題か確認
     * @param int pathstepID pathstep.id
     * @returns bool
     */
    checkEndSection: function(pathstepID) {
      // セクション情報取得
      var sections = this.lessonJson.paths[this.pathIndex].sections;
      if (sections) {
        for (var i = 0; i < sections.length; i++) {
          // セクションのendIDと一致
          if (sections[i].endID == pathstepID) {
            this.log("End of section !!");
            return true;
          }
        }
      }
      return false;
    },
    calcSectionScore: function(endID) {
      // セクション情報取得
      var sections = this.lessonJson.paths[this.pathIndex].sections;
      // pathsteps
      var pathsteps = this.lessonJson.paths[this.pathIndex].pathsteps;
      // スコア情報取得
      var pathScore = this.$store.getters.currentPath;

      if (!sections || !pathsteps || !pathScore) {
        return false;
      }

      // 戻り値
      var ret = {
        total: 0,
        ok: 0,
        ng: 0,
        skip: 0,
        answerRate: 0,
        startPathstepIndex: 0,
        pathScore: []
      };
      // セクション開始、終了ID取得
      var startID = "";
      var scoreThreshold = 0; // 閾値
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].endID == endID) {
          startID = sections[i].startID;
          scoreThreshold = sections[i].scoreThreshold;
          break;
        }
      }
      if (startID == "") {
        return false;
      }

      // スコア情報取得
      var scores = [];
      // セクション要素フラグ
      var isSectionItem = false;
      for (var i = 0; i < pathsteps.length; i++) {
        if (pathsteps[i].id == startID) {
          // セクション開始
          isSectionItem = true;
          // セクション開始Index
          ret.startPathstepIndex = i;
        }

        // 計算
        if (isSectionItem && pathScore.pathsteps[i]) {
          ret.total += pathScore.pathsteps[i].count;
          ret.ok += pathScore.pathsteps[i].ok;
          ret.ng += pathScore.pathsteps[i].ng;
          ret.skip += pathScore.pathsteps[i].skip;
          ret.pathScore.push(pathScore.pathsteps[i]);
        }

        if (pathsteps[i].id == endID) {
          // セクション終了
          break;
        }
      }

      // 正解率
      var total = ret.ok + ret.ng + ret.skip;
      var rate = 0;
      if (total > 0) {
        rate = ret.ok / total;
        ret.answerRate = Math.floor(rate * 100);
      } else {
        return false;
      }
      if (rate >= scoreThreshold) {
        // 閾値以上なら非表示
        return false;
      }

      return ret;
    },
    /**
     * 指定されたPathのリソースをロードしてPathstepsを設定する
     *
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Object} path Path要素
     */
    setPathsteps: async function(unitNo, lessonIndex, path) {
      if (path.resourceID) {
        var language = this.productInfo.language;
        var level = this.levelJson;
        var confuserWordList = this.filterConfuserWordList(level.confuserWordList, unitNo, lessonIndex);
        var pathResource = await this.loadPathResource(path.resourceID, language, level.scriptSystems, confuserWordList);
        path.resourceID = null;
        path.sections = pathResource.sections;
        path.pathsteps = pathResource.pathsteps;
      }
    },
    /**
     * storeのPathレッスンスコアを設定
     */
    setStorePathScore: function(score, levelNo, unitNo, lessonIndex, pathIndex) {
      for (var item of score) {
        var json = JSON.parse(JSON.stringify(item));
        var key = Object.keys(json);
        var split = this.splitScore(json);

        if (split[0] == levelNo && split[1] == unitNo && split[2] == lessonIndex && split[3] == pathIndex) {
          var setParams = "";
          if (split[5] === "ok") {
            setParams = { levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ok: Number(json[key[0]]) };
          } else if (split[5] === "ng") {
            setParams = { levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ng: Number(json[key[0]]) };
          } else {
            setParams = { levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], skip: Number(json[key[0]]) };
          }

          // storeへ設定
          this.$store.dispatch("setPathstep", setParams);
        }
      }
    },
    /**
     * 表示モード切替
     *
     * @param {String} language 言語コード
     * @param {String} pathType Pathタイプ
     */
    changeDisplayMode: function(language, pathType) {
      // 表示モードを非表示にする
      this.$store.dispatch("setShowDisplayMode", false);
      switch (language) {
        case constants.LANGUAGE_CODE_ZHCV:
        case constants.LANGUAGE_CODE_HEIL:
        case constants.LANGUAGE_CODE_JAJP:
          switch (pathType) {
            case storeConstants.PATH_TYPE_READING:
              switch (language) {
                case constants.LANGUAGE_CODE_ZHCV:
                  // 表示モードを簡体字／繁体字（ピンインなし）にする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_NO_PINYIN);
                  break;
                case constants.LANGUAGE_CODE_HEIL:
                  // 表示モードを母音記号ありにする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_VOWELED);
                  break;
                case constants.LANGUAGE_CODE_JAJP:
                  // 表示モードを漢字にする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_KANJI);
                  break;
                default:
                  // Ignore
                  break;
              }
              break;
            case storeConstants.PATH_TYPE_WRITING:
              switch (language) {
                case constants.LANGUAGE_CODE_ZHCV:
                  // 表示モードをピンインのみにする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_PINYIN_ONLY);
                  break;
                case constants.LANGUAGE_CODE_HEIL:
                  // 表示モードを母音記号なしにする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_UNVOWELED);
                  break;
                case constants.LANGUAGE_CODE_JAJP:
                  // 表示モードをローマ字にする
                  this.$store.dispatch("setDisplayMode", constants.DISPLAY_MODE_ROMAJI);
                  break;
                default:
                  // Ignore
                  break;
              }
              break;
            default:
              // 表示モードを表示する
              this.$store.dispatch('setShowDisplayMode', true);
              // 本来の表示モードにする
              var displayMode = this.$store.getters.trueDisplayMode;
              if (displayMode) {
                this.$store.dispatch("setDisplayMode", displayMode);
              }
              break;
          }
          break;
        default:
          // Ignore
          break;
      }
    },
    /**
     * スクロールアイコン表示処理
     *
     * @param {Object} targetElem スクロール対象要素
     */
    showScrollIcon: function(targetElem) {
      if (this.isMobile() && !this.isScrolled) {
        this.isScrollIconVisible = 0 < targetElem.scrollHeight - targetElem.clientHeight;
        if (this.isScrollIconVisible) {
          const self = this;
          const scrollEvent = function(e) {
            clearTimeout(self.scrollIconVisibleTimer);
            self.isScrolled = true;
            self.isScrollIconVisible = false;
            targetElem.removeEventListener("scroll", scrollEvent);
          };
          clearTimeout(this.scrollIconVisibleTimer);
          this.scrollIconVisibleTimer = setTimeout(scrollEvent, constants.SCROLL_ICON_VISIBLE_TIME);
          targetElem.addEventListener("scroll", scrollEvent);
        }
      }
    },
    /**
    * 最終問題か確認
    */
    isLastPathstepIndex: function() {
      var len = this.lessonJson.paths[this.pathIndex].pathsteps.length - 1;
      if(this.pathstepIndex == len) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: async function() {
    this.log("Runmode start created");

    // モバイルアプリコールバック設定
    if (!this.isEnvironmentPc()) {
      // モバイルアプリ版：端末電源ON時の開始コールバック設定
      ROSETTA_SRE_onStart = this.ROSETTA_SRE_onStart;
      // モバイルアプリ版：端末電源OFF時の停止コールバック設定
      ROSETTA_SRE_onStop = this.ROSETTA_SRE_onStop;
      // ドコモ版：プッシュ通知ダイアログ終了コールバック設定
      ROSETTA_onPushSetting = this.ROSETTA_onPushSetting;
      // モバイルアプリ版：アクセスキー無効エラー発生コールバック設定
      ROSETTA_onErrorAccessKey = this.ROSETTA_onErrorAccessKey;
    }

    // state更新
    this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
    this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

    this.showComponent = true;
    this.levelJson = this.getLevelJson(this.jsonData, this.levelNo);

    // マイク設定が必要な場合、マイク設定画面を表示する
    if (this.$store.getters.sreUse == "true" && (await this.needsMicrophoneSetting(sonic_wrapper.getMicrophone()))) {
      this.showMicSelect();
      return;
    }

    // レッスン準備
    this.prepareLesson();
  },
  mounted: function() {
    this.log("Runmode start mounted");

    // ページが可視状態か取得
    var self = this;
    document.addEventListener("visibilitychange", handler);
    function handler() {
      if (document.visibilityState === "visible") {
        // 戻ってきた場合
        if (self.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
          // ダイアログ表示中の場合は、何もしない
          if (self.showLessonScore ||
              self.showSetting ||
              self.showMicrophoneSelect ||
              self.showLanguageLetter ||
              self.showHintDialog ||
              self.showMicrophoneErrorDialog ||
              self.showSectionDialogView ||
              self.showCompletionView ||
              self.showScoreReset ||
              self.showProgressHandOver) {
            return;
          }
          // 引継ぎコード発行画面表示中の場合は、何もしない
          for (var child of self.$parent.$children) {
            if (child.$options.name == "toolbar") {
              if (child.isTakeOverVisible) {
                return;
              } else {
                break;
              }
            }
          }
          // 拡大表示中は何もしない
          if (self.$store.getters.showPinchIn) {
            return;
          }

          // state更新して、レッスンを再開
          self.log("Runmode watch visibilitychange: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
          self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
        }
      } else {
        // 別タブへ移動した場合
        self.audioPause();
        self.log("Runmode watch visibilitychange: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
        self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
      }
    }
  },
  watch: {
    sreUse: function(newSreUse) {
      if (this.$store.getters.lessonState !== storeConstants.LESSON_STATE_PAUSE) {
        return;
      }

      // SREを使用するrunmodeか確認
      var index = constants.RUNMODE_NOT_USE_SRE.indexOf(this.currentMode);
      if (index == -1) {
        // SREを使用するので、state更新して、レッスンを再実施
        this.log("Runmode watch sreUse: set lessonState: " + storeConstants.LESSON_STATE_PREPARE);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);
        this.doStartLesson();
      } else {
        // SREを使用しないので、state更新して、レッスンを再開
        this.log("Runmode watch sreUse: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    textSize: function(newState) {
      // 設定画面にて文字サイズ変更時は再表示
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);
      this.doStartLesson();
    },
    showLessonScore: function(newShowLessonScore) {
      // レッスンスコア画面が表示された場合は何もしない
      if (newShowLessonScore) {
        return;
      }

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        this.showScoreReset = false;

        // state更新して、レッスンを再開
        this.log("Runmode watch showLessonScore: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    showSetting: function(newShowSetting) {
      // 設定画面が表示された場合は何もしない
      if (newShowSetting) {
        return;
      }

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("Runmode watch showSetting: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    showMicrophoneSelect: function(newShowMicrophoneSelect) {
      // マイク選択画面が表示された場合は何もしない
      if (newShowMicrophoneSelect) {
        return;
      }

      // マイク設定確認ダイアログからのマイク選択画面か確認
      if (this.showMicrophoneErrorDialog) {
        this.showMicrophoneErrorDialog = false;

        if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
          // state更新して、レッスンを再開
          this.log("Runmode watch showMicrophoneSelect: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
          this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
        }
      } else if (!this.showSetting) {
        // 設定画面が表示されていない場合、レッスン準備
        this.prepareLesson();
      }
    },
    clickToolbarLogo: function(newLogo) {
      if (!newLogo) {
        // 何もしない
        return;
      }

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    },
    /**
     * 学習言語の文字と発音表示
     * @param bool newshowLanguageLetter
     * @returns {undefined}
     */
    showLanguageLetter: function(newShowLanguageLetter) {
      // 学習言語の文字と発音画面が表示された場合は何もしない
      if (newShowLanguageLetter) {
        return;
      }

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("Runmode watch showLanguageLetter: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * ヒントダイアログ表示監視
     * @param {type} newShowHintDialog
     * @returns {undefined}
     */
    showHintDialog: function(newShowHintDialog) {
      if (newShowHintDialog) {
        // 表示
        this.log("set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
        this.audioPause();
      } else {
        // 非表示
        this.$store.dispatch("setShowHintDialog", false);
        this.isHintHosoku = false;
        if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
          // state更新して、レッスンを再開
          this.log("Runmode watch showHintDialog: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
          this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/runmode_common";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Runmode.vue?4161f8f4